import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryClient";
import type { Board, UUID, Workspace } from "@/lib/types";

interface Vars {
  workspaceId: UUID;
}

export function useDeleteWorkspace() {
  const qc = useQueryClient();
  return useMutation<void, Error, Vars>({
    mutationFn: ({ workspaceId }) => api.deleteWorkspace(workspaceId),
    onSuccess: (_void, { workspaceId }) => {
      // Drop the workspace from the cached list.
      qc.setQueryData<Workspace[]>(queryKeys.workspaces, (prev) =>
        prev ? prev.filter((w) => w.id !== workspaceId) : prev,
      );
      // Cascade soft-delete on the backend killed every child board too; flush
      // every cache that could be holding a now-invisible board.
      qc.setQueryData<Board[]>(queryKeys.myBoards, (prev) =>
        prev ? prev.filter((b) => b.workspace_id !== workspaceId) : prev,
      );
      qc.setQueryData<Board[]>(queryKeys.pinnedBoards, (prev) =>
        prev ? prev.filter((b) => b.workspace_id !== workspaceId) : prev,
      );
      void qc.invalidateQueries({ queryKey: queryKeys.workspaces });
      void qc.invalidateQueries({ queryKey: queryKeys.myBoards });
      void qc.invalidateQueries({ queryKey: queryKeys.pinnedBoards });
      void qc.invalidateQueries({ queryKey: queryKeys.boards(workspaceId) });
    },
  });
}
